import * as v from "valibot";

import { rpcContract } from "../rpc";

export const isFollowingCreatorRpcContract = rpcContract({
  name: "is-following-creator" as const,
  paramsSchema: v.object({
    influencerId: v.string(),
  }),
  resultSchema: v.object({
    isFollowing: v.boolean(),
  }),
});

export type IsFollowingCreatorParams = v.InferInput<typeof isFollowingCreatorRpcContract.paramsSchema>;
export type IsFollowingCreatorResult = v.InferOutput<typeof isFollowingCreatorRpcContract.resultSchema>;
